import React from "react";

interface Props {
  activeColor: string;
}

const LocationIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <path
        d="M24 36C24 36 32 28.5 32 22C32 17.6 28.4 14 24 14C19.6 14 16 17.6 16 22C16 28.5 24 36 24 36Z"
        stroke="#0F1560"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle cx="24" cy="22" r="2.5" fill="#0F1560" />
    </svg>
  );
};

export default LocationIcon;
